export const messages = {
  wronggame: {
    title: "Oyun mevcut değil.",
    message:
      "Böyle bir oyun yok. Lütfen antrenör paneline giriş yap ve tekrar dene.",
    event: "wronggame",
  },
  wrongcode: {
    title: "Cihaz Çakışması",
    message:
      "Muhtemelen oyun başka bir cihazda çalıştırıldı. Eğer bu cihaza taşımak istiyorsan, antrenör paneline giriş yap ve uygun seçeneği kullan.",
    event: "wronggcode",
  },
  expired: {
    title: "Oyun bitti",
    message:
      "Muhtemelen oyun için zaman geçmiştir. Koç panelinize giriş yapın ve oyun listenizi kontrol edin",
    event: "wronggcode",
  },
  missingcredentials: {
    title: "Oyun Sonlandı",
    message:
      "Prawdopodobnie próbujesz uruchomić gre przez przeklejenie linka na inne urządzenie. Zaloguj się do panelu trenera i uruchom grę",
    event: "wronggcode",
  },
  diceTitle: "Bir zar at ve sonucu seç",
  diceOr: "VEYA",
};
export const tu = {
  tutorial: {
    Vipers: {
      name: "Yılan Yuvası",
      effect: "display",
      protection: "careful",
      protectedKarma: 1,
      badKarma1: 6,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Dikkatlice çalılıklardan geçiyorsun. Yakındaki çalılarda hafif hışırtılar duyuyorsun, ama yavaşça uzaklaştıkça her şey sakinleşiyor.",
      badDescription1:
        "Yakındaki çalılıkların yanından geçerken cesaret toplamak için mırıldanıyorsun. Tam o anda kin dolu bir tıslama duyuluyor! Kaçmaya fırsat bulamadan bir engerek baldırlarına atılıyor ve seni fena halde ısırıyor.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Shrubbery: {
      name: "Dikenli Çalılar",
      effect: "display/toss",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 1,
      badKarma2: 1,
      badKarma3: 1,
      badKarma4: 1,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Yol kenarında kolayca yaralanabileceğin pek çok dikenli bitki büyümüş. Yine de sorunlardan ustaca kurtulmayı başardın.",
      badDescription1:
        "Yol kenarında kolayca yaralanabileceğin pek çok dikenli bitki büyümüş. Yine de sorunlardan ustaca kurtulmayı başardın.",
      badDescription2:
        "Yol kenarında kolayca yaralanabileceğin pek çok dikenli bitki büyümüş. Yine de sorunlardan ustaca kurtulmayı başardın.",
      badDescription3:
        "Yol kenarında kolayca yaralanabileceğin pek çok dikenli bitki büyümüş. Yine de sorunlardan ustaca kurtulmayı başardın.",
      badDescription4:
        "Yol kenarında kolayca yaralanabileceğin pek çok dikenli bitki büyümüş. Yine de sorunlardan ustaca kurtulmayı başardın.",
      badDescription5:
        "Yol kenarında kolayca yaralanabileceğin pek çok dikenli bitki büyümüş. Yine de sorunlardan ustaca kurtulmayı başardın.",
      badDescription6:
        "Yol kenarında kolayca yaralanabileceğin pek çok dikenli bitki büyümüş. Yine de sorunlardan ustaca kurtulmayı başardın.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
  },
  game: {
    Village: {
      name: "Bataklık Köyü",
      effect: "display",
      protection: "none",
      protectedKarma: 2,
      badKarma1: 2,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Tuhaf yaratıkların yaşadığı köyün yanından geçiyorsun. Yabancıları pis kokulu çamurla fırlatmak gibi bir alışkanlıkları var. Ne yaptıklarını iyi biliyorlar, çünkü bu kokuyu üstünden temizlemek gerçekten çok zor.",
      badDescription1:
        "Tuhaf yaratıkların yaşadığı köyün yanından geçiyorsun. Yabancıları pis kokulu çamurla fırlatmak gibi bir alışkanlıkları var. Ne yaptıklarını iyi biliyorlar, çünkü bu kokuyu üstünden temizlemek gerçekten çok zor.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Swamps: {
      name: "Bataklık",
      effect: "display",
      protection: "breathing-spell",
      protectedKarma: 1,
      badKarma1: 5,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Bataklığa girdin. Geçiş zahmetli olsa da oldukça sakindi – sadece hava o kadar ağırdı ki sanki baltayı asabilirdin.",
      badDescription1:
        "Bataklığa girdin. Geçiş zahmetli olsa da oldukça sakindi – ama şu yakıcı dumanlar boğazını fena halde tahriş ediyor. Sanki bir şey olmamış gibi görünse de, garip bir şekilde öksürmeye başladın.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Mountains: {
      name: "Delilik Dağları",
      effect: "toss/toss",
      protection: "careful",
      protectedKarma: "nie dotyczy",
      badKarma1: 7,
      badKarma2: 17,
      badKarma3: 15,
      badKarma4: 18,
      badKarma5: 10,
      badKarma6: 19,
      worseKarma1: 7,
      worseKarma2: 7,
      worseKarma3: 17,
      worseKarma4: 17,
      worseKarma5: 18,
      worseKarma6: 15,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Delilik havası yüzünden uçuruma atlamanı söyleyen sesler duyuyorsun. Kafanın karıştığını hissediyorsun, ama itaatle kenara gidip atlıyorsun. Senin yardımına koşmak için herkes işini bıraktı ve aceleyle yanına geldi.",
      badDescription2:
        "Delilik havası yüzünden uçuruma atlamanı söyleyen sesler duyuyorsun. Son anda kendine geldin, ama içindeki seslerin sonsuza dek seninle kalacağı hissine sahipsin.",
      badDescription3:
        "Delilik havası yüzünden uçuruma atlamanı söyleyen sesler duyuyorsun. Son anda kendine geldin, ama içindeki seslerin sonsuza dek seninle kalacağı hissine sahipsin.",
      badDescription4:
        "Dağ manzaraları inanılmaz etkileyici. Ama ne fayda, hayranlıkla bakarken sendelediğin ve fena halde yaralandığın için keyfin kaçtı.",
      badDescription5:
        "Dağ manzaraları inanılmaz etkileyici. Ama ne fayda, hayranlıkla bakarken sendelediğin ve çıkıntı yapan bir taşa yanağını çarptığın için kanamaya başladın.",
      badDescription6:
        "Dağlar da dağdır: çevre delilik derecesinde monoton. Sanki burada birkaç kez daha bulunmuşsun gibi hissediyorsun. Doğru yolu bulamayıp sürekli aynı yerde dönüp duruyorsun.",
      worseDescription1:
        "Delilik havası yüzünden uçuruma atlamanı söyleyen sesler duyuyorsun. Kafanın karıştığını hissediyorsun, ama itaatle kenara gidip atlıyorsun. Senin yardımına koşmak için herkes işini bıraktı ve aceleyle yanına geldi.",
      worseDescription2:
        "Delilik havası yüzünden uçuruma atlamanı söyleyen sesler duyuyorsun. Kafanın karıştığını hissediyorsun, ama itaatle kenara gidip atlıyorsun. Senin yardımına koşmak için herkes işini bıraktı ve aceleyle yanına geldi.",
      worseDescription3:
        "Delilik havası yüzünden uçuruma atlamanı söyleyen sesler duyuyorsun. Son anda kendine geldin, ama içindeki seslerin sonsuza dek seninle kalacağı hissine sahipsin.",
      worseDescription4:
        "Delilik havası yüzünden uçuruma atlamanı söyleyen sesler duyuyorsun. Son anda kendine geldin, ama içindeki seslerin sonsuza dek seninle kalacağı hissine sahipsin.",
      worseDescription5:
        "Dağ manzaraları inanılmaz etkileyici. Ama ne fayda, hayranlıkla bakarken sendelediğin ve fena halde yaralandığın için keyfin kaçtı.",
      worseDescription6:
        "Delilik havası yüzünden uçuruma atlamanı söyleyen sesler duyuyorsun. Son anda kendine geldin, ama içindeki seslerin sonsuza dek seninle kalacağı hissine sahipsin.",
    },
    Footbridge: {
      name: "Tahta Köprü",
      effect: "display",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 8,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Köprü dengesiz olduğu için suya düşüyorsun. Altında huysuz bir trol yaşıyor. Senden hoşlandı, bu yüzden sana zarar vermedi ve güvenle karşı kıyıya çıktın.",
      badDescription1:
        "Köprü dengesiz olduğu için suya düşüyorsun. Altında huysuz bir trol yaşıyor. Senden hiç hoşlanmadı, bu yüzden seni gürzüyle dövdü — zar zor sürünerek karşı kıyıya çıktın.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Avalanche: {
      name: "Taş Çığı",
      effect: "display/toss",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 9,
      badKarma2: 9,
      badKarma3: 9,
      badKarma4: 9,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Yürüdüğün yola taşlar düşüyor, ama hiçbiri sana sertçe çarpmadan kurtuluyorsun",
      badDescription1:
        "Yürüdüğün yola taşlar düşüyor ve onlardan biri kafana isabet ediyor. Hem sersemliyorsun hem de kocaman bir şiş çıkıyor.",
      badDescription2:
        "Yürüdüğün yola taşlar düşüyor ve onlardan biri kafana isabet ediyor. Hem sersemliyorsun hem de kocaman bir şiş çıkıyor.",
      badDescription3:
        "Yürüdüğün yola taşlar düşüyor ve onlardan biri kafana isabet ediyor. Hem sersemliyorsun hem de kocaman bir şiş çıkıyor.",
      badDescription4:
        "Yürüdüğün yola taşlar düşüyor ve onlardan biri kafana isabet ediyor. Hem sersemliyorsun hem de kocaman bir şiş çıkıyor.",
      badDescription5:
        "Yürüdüğün yola taşlar düşüyor, ama hiçbiri sana sertçe çarpmadan kurtuluyorsun",
      badDescription6:
        "Yürüdüğün yola taşlar düşüyor, ama hiçbiri sana sertçe çarpmadan kurtuluyorsun",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Generator: {
      name: "Büyülü Jeneratör",
      effect: "generator",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 5,
      badKarma2: 15,
      badKarma3: 20,
      badKarma4: 10,
      badKarma5: 21,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Etrafta büyücülerin yaptığına kesin gözüyle bakılan garip yapılar dağılmış durumda. Herkes bilir ki büyücüler böyle tuhaf şeyler inşa eder. Direkler arasında neşeyle zıplayan büyülü kıvılcımlar gözünü alıyor. Oldukça hoşuna gidiyor – sonuçta bu kadar renkli bir şey rzadko masz okazję oglądać.",
      badDescription1:
        "Etrafta büyücülerin yaptığına kesin gözüyle bakılan garip yapılar dağılmış durumda. Herkes bilir ki büyücüler böyle tuhaf şeyler inşa eder. Direkler arasında elektriklenmeler kıvılcım saçıyor. Onlardan biri sana isabet ediyor ve nefes alamıyorsun. Boğuluyor gibi oluyorsun ama birkaç saniye sonra geçiyor. Galiba endişelenecek bir şey yok.",
      badDescription2:
        "Etrafta büyücülerin yaptığına kesin gözüyle bakılan garip yapılar dağılmış durumda. Herkes bilir ki büyücüler böyle tuhaf şeyler inşa eder. Direkler arasında elektriklenmeler kıvılcım saçıyor. Onlardan biri sana isabet ediyor ve bir anda kim olduğunu ya da nerede olduğunu hatırlamıyorsun. Hafızan bulanıklaşıyor, ama birkaç saniye sonra geçiyor. Galiba endişelenecek bir şey yok.",
      badDescription3:
        "Etrafta büyücülerin yaptığına kesin gözüyle bakılan garip yapılar dağılmış durumda. Herkes bilir ki büyücüler böyle tuhaf şeyler inşa eder. Direkler arasında elektriklenmeler kıvılcım saçıyor. Onlardan biri sana isabet ediyor ve kaşlarını yakıyor. Nasıl olsa yeniden çıkarlar, o yüzden galiba endişelenecek bir şey yok.",
      badDescription4:
        "Etrafta büyücülerin yaptığına kesin gözüyle bakılan garip yapılar dağılmış durumda. Herkes bilir ki büyücüler böyle tuhaf şeyler inşa eder. Direkler arasında elektriklenmeler kıvılcım saçıyor. Onlardan biri sana isabet ediyor ve elini yakıyor. Nasıl olsa iyileşir, o yüzden galiba endişelenecek bir şey yok.",
      badDescription5:
        "Etrafta büyücülerin yaptığına kesin gözüyle bakılan garip yapılar dağılmış durumda. Herkes bilir ki büyücüler böyle tuhaf şeyler inşa eder. Direkler arasında elektriklenmeler kıvılcım saçıyor. Onlardan biri sana isabet ediyor ve seni geriye savuruyor. Yere düşüyorsun ve biraz acıyor ama galiba endişelenecek bir şey yok.",
      badDescription6:
        "Etrafta büyücülerin yaptığına kesin gözüyle bakılan garip yapılar dağılmış durumda. Herkes bilir ki büyücüler böyle tuhaf şeyler inşa eder. Direkler arasında elektriklenmeler kıvılcım saçıyor. Onlardan biri neredeyse sana çarpacakken kıl payı yanından geçiyor.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Glade: {
      name: "Avcı Açıklığı",
      effect: "display",
      protection: "breastplate",
      protectedKarma: 1,
      badKarma1: 10,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        " Avcıların pusuda beklediği bir açıklığın yanından geçiyorsun. Uzaktan sana neşeyle el sallıyorlar.",
      badDescription1:
        "Avcıların pusuda beklediği bir açıklığın yanından geçiyorsun. Tam o sırada yanından bir tilki geçiyor. Ardından bir ıslık sesi duyuluyor ve kalçanda bir sızı hissediyorsun – tilki için atılmış bir ok seni sıyırdı. Neyse ki yara sadece yüzeysel.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Ruins: {
      name: "Kasvetli Harabeler",
      effect: "display",
      protection: "none",
      protectedKarma: 3,
      badKarma1: 3,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Hedefine giden daha kısa bir yol umuduyla harabelerin arasına dalıyorsun. Yıkılmak üzere olan bir kuleyi dikkatle geçmeye çalışırken, birden – nereden çıktığı belli olmayan – üstü başı dökülmüş yaşlı bir adam önüne atlıyor ve seni beş kuşak öncene kadar lanetlemeye başlıyor! Hakaret duvarını aşamıyorsun. Mahcup bir halde oradan uzaklaşıyorsun. Bu sarsıcı karşılaşmanın etkisinden uzun süre kurtulamıyorsun.",
      badDescription1:
        "Hedefine giden daha kısa bir yol umuduyla harabelerin arasına dalıyorsun. Yıkılmak üzere olan bir kuleyi dikkatle geçmeye çalışırken, birden – nereden çıktığı belli olmayan – üstü başı dökülmüş yaşlı bir adam önüne atlıyor ve seni beş kuşak öncene kadar lanetlemeye başlıyor! Hakaret duvarını aşamıyorsun. Mahcup bir halde oradan uzaklaşıyorsun. Bu sarsıcı karşılaşmanın etkisinden uzun süre kurtulamıyorsun.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Forest: {
      name: "Kasvetli Orman",
      effect: "display",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 1,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Ormanın içinden geçerken, her an üstüne bir kâbus çökecekmiş gibi hissediyorsun. Neyse ki ağaçların arasından artık açıklık görünüyor — birkaç adım kaldı ve güvendesin.",
      badDescription1:
        "Ormanın içinden geçerken, her an üstüne bir kâbus çökecekmiş gibi hissediyorsun. Neyse ki ağaçların arasından artık açıklık görünüyor — birkaç adım kaldı ve güvendesin.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Crossing: {
      name: "Yüzerek Geçiş",
      effect: "toss/toss",
      protection: "breathing-spell",
      protectedKarma: "nie dotyczy",
      badKarma1: 11,
      badKarma2: 11,
      badKarma3: 22,
      badKarma4: 22,
      badKarma5: 6,
      badKarma6: 5,
      worseKarma1: 11,
      worseKarma2: 11,
      worseKarma3: 11,
      worseKarma4: 11,
      worseKarma5: 22,
      worseKarma6: 6,
      protectedDescription: "nie dotyczy",
      badDescription1:
        " Nehir sakin görünse de aslında çok sinsi. Son bir nefes almak istiyorsun ama artık üzerinde sadece su var. Suyu yutuyorsun, boğuluyorsun, ciğerlerin içten içe yanıyor. Kıyıdan biri yardım çağırıyor. Seni kurtarıyorlar, ama vücudun artık eskisi gibi işlemiyor. O andan itibaren biraz daha yavaş hareket ediyorsun, her şey artık daha çok zaman alıyor.",
      badDescription2:
        " Nehir sakin görünse de aslında çok sinsi. Son bir nefes almak istiyorsun ama artık üzerinde sadece su var. Suyu yutuyorsun, boğuluyorsun, ciğerlerin içten içe yanıyor. Kıyıdan biri yardım çağırıyor. Seni kurtarıyorlar, ama vücudun artık eskisi gibi işlemiyor. O andan itibaren biraz daha yavaş hareket ediyorsun, her şey artık daha çok zaman alıyor.",
      badDescription3:
        "Nehir sakin görünse de aslında çok sinsi. Onu geçmek, senin gibi bir kahraman için bile büyük bir sınav. Su yutarken, son gücünle kıyıya ulaşıyorsun. Ölümle burun buruna geldiğini hissediyorsun ve bir daha asla eskisi kadar kaygısız olmayacağını biliyorsun.",
      badDescription4:
        "Nehir sakin görünse de aslında çok sinsi. Onu geçmek, senin gibi bir kahraman için bile büyük bir sınav. Su yutarken, son gücünle kıyıya ulaşıyorsun. Ölümle burun buruna geldiğini hissediyorsun ve bir daha asla eskisi kadar kaygısız olmayacağını biliyorsun.",
      badDescription5:
        "Nehir sakin görünse de aslında çok sinsi. Sayısız kez su yutuyorsun ama sonunda diğer kıyıya varıyorsun. Uzun süre nefes nefese kalıyor ve artık biraz hırıltılı nefes alıyorsun. Bu kadar zor olacağını sanmamıştın.",
      badDescription6:
        "Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Zachłystujesz się wodą niezliczoną ilość razy ale dopływasz na drugi brzeg. Myślałeś, że będzie łatwiej.",
      worseDescription1:
        "Nehir sakin görünse de aslında çok sinsi. Son bir nefes almak istiyorsun ama artık üzerinde sadece su var. Suyu yutuyorsun, boğuluyorsun, ciğerlerin içten içe yanıyor. Kıyıdan biri yardım çağırıyor. Seni kurtarıyorlar, ama vücudun artık eskisi gibi işlemiyor. O andan itibaren biraz daha yavaş hareket ediyorsun, her şey artık daha çok zaman alıyor.",
      worseDescription2:
        "Nehir sakin görünse de aslında çok sinsi. Son bir nefes almak istiyorsun ama artık üzerinde sadece su var. Suyu yutuyorsun, boğuluyorsun, ciğerlerin içten içe yanıyor. Kıyıdan biri yardım çağırıyor. Seni kurtarıyorlar, ama vücudun artık eskisi gibi işlemiyor. O andan itibaren biraz daha yavaş hareket ediyorsun, her şey artık daha çok zaman alıyor.",
      worseDescription3:
        "Nehir sakin görünse de aslında çok sinsi. Son bir nefes almak istiyorsun ama artık üzerinde sadece su var. Suyu yutuyorsun, boğuluyorsun, ciğerlerin içten içe yanıyor. Kıyıdan biri yardım çağırıyor. Seni kurtarıyorlar, ama vücudun artık eskisi gibi işlemiyor. O andan itibaren biraz daha yavaş hareket ediyorsun, her şey artık daha çok zaman alıyor.",
      worseDescription4:
        "Nehir sakin görünse de aslında çok sinsi. Son bir nefes almak istiyorsun ama artık üzerinde sadece su var. Suyu yutuyorsun, boğuluyorsun, ciğerlerin içten içe yanıyor. Kıyıdan biri yardım çağırıyor. Seni kurtarıyorlar, ama vücudun artık eskisi gibi işlemiyor. O andan itibaren biraz daha yavaş hareket ediyorsun, her şey artık daha çok zaman alıyor.",
      worseDescription5:
        "Nehir sakin görünse de aslında çok sinsi. Onu geçmek, senin gibi bir kahraman için bile büyük bir sınav. Su yutarken, son gücünle kıyıya ulaşıyorsun. Ölümle burun buruna geldiğini hissediyorsun ve bir daha asla eskisi kadar kaygısız olmayacağını biliyorsun.",
      worseDescription6:
        "Nehir sakin görünse de aslında çok sinsi. Sayısız kez su yutuyorsun ama sonunda diğer kıyıya varıyorsun. Uzun süre nefes nefese kalıyor ve artık biraz hırıltılı nefes alıyorsun. Bu kadar zor olacağını sanmamıştın.",
    },
    Dragon: {
      name: "Ejderha",
      effect: "display",
      protection: "antiflame-spell",
      protectedKarma: 4,
      badKarma1: 12,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Bir ejderha mağarasının yanından geçerken sahibini uyandırıyorsun. Ejderha ininden dışarı sürünüyor ve tüm çevreye ateş kusuyor.",
      badDescription1:
        "Bir ejderha mağarasının yanından geçerken sahibini uyandırıyorsun. Ejderha ininden dışarı sürünüyor ve tüm çevreye ateş kusuyor.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Appiary: {
      name: "Eski Arıcılık Alanı",
      effect: "toss/toss",
      protection: "careful",
      protectedKarma: "nie dotyczy",
      badKarma1: 13,
      badKarma2: 2,
      badKarma3: 2,
      badKarma4: 2,
      badKarma5: 20,
      badKarma6: 20,
      worseKarma1: 13,
      worseKarma2: 13,
      worseKarma3: 13,
      worseKarma4: 2,
      worseKarma5: 2,
      worseKarma6: 2,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Mutasyona uğramış zehirli arıları kızdırdın. En yakında sen olduğun için en çok sen etkilendin. Şişmiş halinle gerçekten berbat görünüyorsun. Üstelik arılar kovanlardan çıkıp tüm Diyarı sokuyor. Artık hayatta kalmak için herkesin her sabah zaman alan bir panzehir hazırlaması gerekecek.",
      badDescription2:
        "Arıları kızdırdın. Kovandan çıktılar ve başının her yerinden seni soktular. Şişmiş halinle gerçekten berbat görünüyorsun.",
      badDescription3:
        "Arıları kızdırdın. Kovandan çıktılar ve başının her yerinden seni soktular. Şişmiş halinle gerçekten berbat görünüyorsun.",
      badDescription4:
        "Arıları kızdırdın. Kovandan çıktılar ve başının her yerinden seni soktular. Şişmiş halinle gerçekten berbat görünüyorsun.",
      badDescription5:
        "Arıları kızdırdın. Kovandan çıktılar ve başının her yerinden seni soktular. Şişmiş halinle gerçekten berbat görünüyorsun.",
      badDescription6:
        "Arıları kızdırdın. Kovandan çıktılar ve başının her yerinden seni soktular. Şişmiş halinle gerçekten berbat görünüyorsun.",
      worseDescription1:
        "Mutasyona uğramış zehirli arıları kızdırdın. En yakında sen olduğun için en çok sen etkilendin. Şişmiş halinle gerçekten berbat görünüyorsun. Üstelik arılar kovanlardan çıkıp tüm Diyarı sokuyor. Artık hayatta kalmak için herkesin her sabah zaman alan bir panzehir hazırlaması gerekecek.",
      worseDescription2:
        "Mutasyona uğramış zehirli arıları kızdırdın. En yakında sen olduğun için en çok sen etkilendin. Şişmiş halinle gerçekten berbat görünüyorsun. Üstelik arılar kovanlardan çıkıp tüm Diyarı sokuyor. Artık hayatta kalmak için herkesin her sabah zaman alan bir panzehir hazırlaması gerekecek.",
      worseDescription3:
        "Mutasyona uğramış zehirli arıları kızdırdın. En yakında sen olduğun için en çok sen etkilendin. Şişmiş halinle gerçekten berbat görünüyorsun. Üstelik arılar kovanlardan çıkıp tüm Diyarı sokuyor. Artık hayatta kalmak için herkesin her sabah zaman alan bir panzehir hazırlaması gerekecek.",
      worseDescription4:
        "Arıları kızdırdın. Kovandan çıktılar ve başının her yerinden seni soktular. Şişmiş halinle gerçekten berbat görünüyorsun.",
      worseDescription5:
        "Arıları kızdırdın. Kovandan çıktılar ve başının her yerinden seni soktular. Şişmiş halinle gerçekten berbat görünüyorsun.",
      worseDescription6:
        "Arıları kızdırdın. Kovandan çıktılar ve başının her yerinden seni soktular. Şişmiş halinle gerçekten berbat görünüyorsun.",
    },
    Slippery: {
      name: "Kaygan ",
      effect: "display/toss",
      protection: "careful",
      protectedKarma: 1,
      badKarma1: 14,
      badKarma2: 23,
      badKarma3: 23,
      badKarma4: 23,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Yolda gerçekten kötü koşullar var ama şans eseri kaymaktan kurtuldun.",
      badDescription1:
        "Yolda gerçekten kötü koşullar var ve maalesef kaydın. Ciddi bir şey olmadı, sadece kalan hareketini toparlanmaya harcadın. Ayrıca kısa bir süre hafifçe topallıyorsun.",
      badDescription2:
        "Yolda gerçekten kötü koşullar var ve maalesef kaydın. Ciddi bir şey olmadı ama kısa bir süre hafifçe topallıyorsun. Bunu sağlık görevlisine gösterebilirsin YA DA dişini sıkıp devam edebilirsin — sonuçta sadece bir ezilme.",
      badDescription3:
        "Yolda gerçekten kötü koşullar var ve maalesef kaydın. Ciddi bir şey olmadı ama kısa bir süre hafifçe topallıyorsun. Bunu sağlık görevlisine gösterebilirsin YA DA dişini sıkıp devam edebilirsin — sonuçta sadece bir ezilme.",
      badDescription4:
        "Yolda gerçekten kötü koşullar var ve maalesef kaydın. Ciddi bir şey olmadı ama kısa bir süre hafifçe topallıyorsun. Bunu sağlık görevlisine gösterebilirsin YA DA dişini sıkıp devam edebilirsin — sonuçta sadece bir ezilme.",
      badDescription5:
        "Yolda gerçekten kötü koşullar var ama şans eseri kaymaktan kurtuldun.",
      badDescription6:
        "Yolda gerçekten kötü koşullar var ama şans eseri kaymaktan kurtuldun.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Wilderness: {
      name: "Kutsal Alan",
      effect: "display",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 15,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Duyduğuna göre kutsal alanda rusaçkalar dans ediyormuş, geçerken şarkılarıyla büyülüyormuş insanları. Bu aslında ilginç olabilirdi, ama sen hiç bir şarkı duymuyorsun. Hayal kırıklığıyla yürümeye devam ediyorsun.",
      badDescription1:
        "Kutsal alandan geçerken neşeli ve büyüleyici bir şarkı duyuyorsun. Biraz müzikten kimse ölmedi. Yürümeye devam ediyorsun, melodi sana yapışmış gibi, sürekli mırıldanıyorsun.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Volcano: {
      name: "Volkan",
      effect: "toss/toss",
      protection: "antiflame-spell",
      protectedKarma: "nie dotyczy",
      badKarma1: 16,
      badKarma2: 16,
      badKarma3: 10,
      badKarma4: 10,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: 24,
      worseKarma2: 24,
      worseKarma3: 16,
      worseKarma4: 16,
      worseKarma5: 10,
      worseKarma6: 10,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor, bu yüzden lavaya düşmemek için keskin bir kayanın kenarına tutunuyorsun. Kurtuluyorsun ama ellerini yaralıyorsun ve üstüne lavın sıçraması yüzünde delikler açıyor.",
      badDescription2:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor, bu yüzden lavaya düşmemek için keskin bir kayanın kenarına tutunuyorsun. Kurtuluyorsun ama ellerini yaralıyorsun ve üstüne lavın sıçraması yüzünde delikler açıyor.",
      badDescription3:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor, bu yüzden lavaya düşmemek için keskin kayanın kenarına tutunuyorsun. Kurtuluyorsun ama ellerini yaralıyorsun.",
      badDescription4:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor, bu yüzden lavaya düşmemek için keskin kayanın kenarına tutunuyorsun. Kurtuluyorsun ama ellerini yaralıyorsun.",
      badDescription5:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor ama dengeni koruyorsun",
      badDescription6:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor ama dengeni koruyorsun",
      worseDescription1:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor, bu yüzden lavaya düşmemek için keskin bir kayanın kenarına tutunuyorsun. Kurtuluyorsun ama ellerini yaralıyorsun ve üstüne lavın sıçraması yüzünde delikler açıyor.",
      worseDescription2:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor, bu yüzden lavaya düşmemek için keskin bir kayanın kenarına tutunuyorsun. Kurtuluyorsun ama ellerini yaralıyorsun ve üstüne lavın sıçraması yüzünde delikler açıyor.",
      worseDescription3:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor, bu yüzden lavaya düşmemek için keskin bir kayanın kenarına tutunuyorsun. Kurtuluyorsun ama ellerini yaralıyorsun ve üstüne lavın sıçraması yüzünde delikler açıyor.",
      worseDescription4:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor, bu yüzden lavaya düşmemek için keskin bir kayanın kenarına tutunuyorsun. Kurtuluyorsun ama ellerini yaralıyorsun ve üstüne lavın sıçraması yüzünde delikler açıyor.",
      worseDescription5:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor, bu yüzden lavaya düşmemek için keskin kayanın kenarına tutunuyorsun. Kurtuluyorsun ama ellerini yaralıyorsun.",
      worseDescription6:
        "Patika kraterin kenarından gidiyor. Yürürken zemin ayaklarının altından kayıyor, bu yüzden lavaya düşmemek için keskin kayanın kenarına tutunuyorsun. Kurtuluyorsun ama ellerini yaralıyorsun.",
    },
  },
};
